import Infographic from './infographic'
import { createApp } from '@/vue-kit'

const infographic = new Infographic()

createApp({
  el: '#infographic-page'
})

export default {
  instance: infographic
}
